export default "__VITE_ASSET__BMAz1uJs__"